import { getMockedApi } from "../../components/portal/api_to_state";
import { State, ExtraUserInfo } from "../portal_client";
import * as PortalApi from "../../portal_generated_api"
import { Product, Characteristic, CharacteristicValue, QuotationResponse, SubmitQuotationData } from '../portal/types';
import { HttpResult, } from 'widgets-for-react'
import { BasicCredentials } from "../portal/state";
import { pushEventToDatalayer } from '../../utils/analytics';

export let api_object = {...getMockedApi<State, ExtraUserInfo>(),
  login:(x: BasicCredentials & {role?: string}, useTwoFactor?: string | false) => PortalApi.login(x, useTwoFactor).then(res => {
    if (res.status == "success") {
      pushEventToDatalayer({ category: "Login", action: "Submit" })
    }
    return res
  }),
  logout:PortalApi.logout,
  resend_account_activation:PortalApi.request_activation_email,
  change_pasword:PortalApi.change_password,
  request_reset_password:PortalApi.request_reset_password,
  reset_password:PortalApi.reset_password,
  activate_account:PortalApi.activate_account,
  verifyResetPasswordToken:PortalApi.verifyResetPasswordToken
}

export async function getProducts(language_code: string): Promise<HttpResult<Product[]>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let response: Response
  try {
    response = await fetch(`/api/v1/products/get?langCode=${language_code}`, {
      method: 'get',
      credentials: 'include',
      headers: headers
    })
  } catch {
    return { kind: 'failed', status: 0 }
  }
  if (!response.ok) {
    return { kind: 'failed', status: response.status }
  }

  try {
    let products = await response.json()
    return { kind: 'result', value: products, status: 200}
  } catch {
    return { kind: 'failed', status: 200 }
  }
}

export async function getCharacteristics(language_code: string, product_id: string, characteristic_values: CharacteristicValue[]): Promise<HttpResult<Characteristic[]>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let response: Response
  try {
    response = await fetch(`/api/v1/characteristics/update`, {
      method: 'post',
      body: JSON.stringify({ languageCode: language_code, productId: product_id, characteristicValues: characteristic_values }),
      credentials: 'include',
      headers: headers
    })
  } catch {
    return { kind: 'failed', status: 0 }
  }
  if (!response.ok) {
    return { kind: 'failed', status: response.status }
  }

  try {
    let characteristics = await response.json()
    return { kind: 'result', value: characteristics, status: 200}
  } catch {
    return { kind: 'failed', status: 200}
  }
}

export async function getNewQuotation(quotation: SubmitQuotationData): Promise<HttpResult<QuotationResponse>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let response: Response
  try {
    response = await fetch(`/api/v1/quotation_request/new`, {
      method: 'post',
      body: JSON.stringify(quotation),
      credentials: 'include',
      headers: headers
    })
  } catch {
    return { kind: 'failed', status: 0 }
  }
  if (!response.ok) {
    return { kind: 'failed', status: response.status }
  }

  try {
    let quotationResponse = await response.json()
    return { kind: 'result', value: quotationResponse, status: 200 }
  } catch {
    return { kind: 'failed', status: 200 }
  }
}
